module.exports = __webpack_public_path__ + "img/snack_bar.c8317230.png";